export default __webpack_public_path__ + "static/media/projectoB.56ffaa33.jpg";